// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/policy/v1/policy_steps_wait.proto" (package "c1.api.policy.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { MessageType } from "@protobuf-ts/runtime";
import { SkippedAction } from "./shared_policy_outcomes";
import { Timestamp } from "../../../../google/protobuf/timestamp";
import { Duration } from "../../../../google/protobuf/duration";
/**
 * Define a Wait step for a policy to wait on a condition to be met.
 *
 * @generated from protobuf message c1.api.policy.v1.Wait
 */
export interface Wait {
    /**
     * @generated from protobuf oneof: until
     */
    until: {
        oneofKind: "condition";
        /**
         * Wait for a certain condition to be met defined by a CEL expression.
         *
         * @generated from protobuf field: c1.api.policy.v1.WaitCondition condition = 100;
         */
        condition: WaitCondition;
    } | {
        oneofKind: "duration";
        /**
         * @generated from protobuf field: c1.api.policy.v1.WaitDuration duration = 101;
         */
        duration: WaitDuration;
    } | {
        oneofKind: "untilTime";
        /**
         * @generated from protobuf field: c1.api.policy.v1.WaitUntilTime until_time = 102;
         */
        untilTime: WaitUntilTime;
    } | {
        oneofKind: undefined;
    };
    /**
     * The name of our condition to show on the task details page
     *
     * @generated from protobuf field: string name = 1;
     */
    name: string;
    /**
     * This condition will only wait this long to continue. If not the task will close.
     *
     * @generated from protobuf field: google.protobuf.Duration timeout_duration = 2;
     */
    timeoutDuration?: Duration;
    /**
     * The comment to post if we timeout.
     *
     * @generated from protobuf field: string comment_on_timeout = 3;
     */
    commentOnTimeout: string;
    /**
     * The comment to post on first failed check.
     *
     * @generated from protobuf field: string comment_on_first_wait = 4;
     */
    commentOnFirstWait: string;
}
/**
 * @generated from protobuf message c1.api.policy.v1.WaitCondition
 */
export interface WaitCondition {
    /**
     * The condition that has to be true for this wait condition to continue.
     *
     * @generated from protobuf field: string condition = 1;
     */
    condition: string;
}
/**
 * @generated from protobuf message c1.api.policy.v1.WaitDuration
 */
export interface WaitDuration {
    /**
     * @generated from protobuf field: google.protobuf.Duration duration = 1;
     */
    duration?: Duration;
}
/**
 * Waits until a specific time of the day (UTC)
 *
 * @generated from protobuf message c1.api.policy.v1.WaitUntilTime
 */
export interface WaitUntilTime {
    /**
     * @generated from protobuf field: uint32 hours = 1;
     */
    hours: number;
    /**
     * @generated from protobuf field: uint32 minutes = 2;
     */
    minutes: number;
    /**
     * @generated from protobuf field: string timezone = 3;
     */
    timezone: string;
}
/**
 * Used by the policy engine to describe an instantiated wait step.
 *
 * @generated from protobuf message c1.api.policy.v1.WaitInstance
 */
export interface WaitInstance {
    /**
     * @generated from protobuf oneof: until
     */
    until: {
        oneofKind: "condition";
        /**
         * @generated from protobuf field: c1.api.policy.v1.WaitConditionInstance condition = 100;
         */
        condition: WaitConditionInstance;
    } | {
        oneofKind: "untilTime";
        /**
         * @generated from protobuf field: c1.api.policy.v1.WaitUntilTimeInstance until_time = 104;
         */
        untilTime: WaitUntilTimeInstance;
    } | {
        oneofKind: undefined;
    };
    /**
     * @generated from protobuf field: string name = 1;
     */
    name: string;
    /**
     * @generated from protobuf field: c1.api.policy.v1.WaitInstance.WaitInstanceState state = 2;
     */
    state: WaitInstance_WaitInstanceState;
    /**
     * This was when we started waiting for the condition to be met.
     *
     * @generated from protobuf field: google.protobuf.Timestamp started_waiting_at = 3;
     */
    startedWaitingAt?: Timestamp;
    /**
     * This was how long the step was configured to wait for
     *
     * @generated from protobuf field: google.protobuf.Duration timeout_duration = 4;
     */
    timeoutDuration?: Duration;
    /**
     * This condition will only wait until this time to continue. This value is calculated as (time_step_began + timeout).
     *
     * @generated from protobuf field: google.protobuf.Timestamp timeout = 5;
     */
    timeout?: Timestamp;
    /**
     * The comment to post if we timeout.
     *
     * @generated from protobuf field: string comment_on_timeout = 6;
     */
    commentOnTimeout: string;
    /**
     * The comment to post on first failed check.
     *
     * @generated from protobuf field: string comment_on_first_wait = 7;
     */
    commentOnFirstWait: string;
    /**
     * @generated from protobuf oneof: outcome
     */
    outcome: {
        oneofKind: "succeeded";
        /**
         * @generated from protobuf field: c1.api.policy.v1.WaitInstance.ConditionSucceeded succeeded = 101;
         */
        succeeded: WaitInstance_ConditionSucceeded;
    } | {
        oneofKind: "timedOut";
        /**
         * @generated from protobuf field: c1.api.policy.v1.WaitInstance.ConditionTimedOut timed_out = 102;
         */
        timedOut: WaitInstance_ConditionTimedOut;
    } | {
        oneofKind: "skipped";
        /**
         * @generated from protobuf field: c1.api.policy.v1.SkippedAction skipped = 103;
         */
        skipped: SkippedAction;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.policy.v1.WaitInstance.ConditionSucceeded
 */
export interface WaitInstance_ConditionSucceeded {
    /**
     * @generated from protobuf field: google.protobuf.Timestamp succeeded_at = 1;
     */
    succeededAt?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.policy.v1.WaitInstance.ConditionTimedOut
 */
export interface WaitInstance_ConditionTimedOut {
    /**
     * @generated from protobuf field: google.protobuf.Timestamp timed_out_at = 1;
     */
    timedOutAt?: Timestamp;
}
/**
 * @generated from protobuf enum c1.api.policy.v1.WaitInstance.WaitInstanceState
 */
export enum WaitInstance_WaitInstanceState {
    /**
     * @generated from protobuf enum value: WAIT_INSTANCE_STATE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: WAIT_INSTANCE_STATE_WAITING = 1;
     */
    WAITING = 1,
    /**
     * @generated from protobuf enum value: WAIT_INSTANCE_STATE_COMPLETED = 2;
     */
    COMPLETED = 2,
    /**
     * @generated from protobuf enum value: WAIT_INSTANCE_STATE_TIMED_OUT = 3;
     */
    TIMED_OUT = 3
}
/**
 * Used by the policy engine to describe an instantiated condition to wait on.
 *
 * @generated from protobuf message c1.api.policy.v1.WaitConditionInstance
 */
export interface WaitConditionInstance {
    /**
     * The condition that has to be true for this wait condition instance to continue.
     *
     * @generated from protobuf field: string condition = 1;
     */
    condition: string;
}
/**
 * @generated from protobuf message c1.api.policy.v1.WaitUntilTimeInstance
 */
export interface WaitUntilTimeInstance {
    /**
     * @generated from protobuf field: google.protobuf.Timestamp until_time = 1;
     */
    untilTime?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Duration duration_if_exists = 2;
     */
    durationIfExists?: Duration;
}
// @generated message type with reflection information, may provide speed optimized methods
class Wait$Type extends MessageType<Wait> {
    constructor() {
        super("c1.api.policy.v1.Wait", [
            { no: 100, name: "condition", kind: "message", oneof: "until", T: () => WaitCondition },
            { no: 101, name: "duration", kind: "message", oneof: "until", T: () => WaitDuration },
            { no: 102, name: "until_time", kind: "message", oneof: "until", T: () => WaitUntilTime },
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "timeout_duration", kind: "message", T: () => Duration },
            { no: 3, name: "comment_on_timeout", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { maxBytes: "4096" } } } },
            { no: 4, name: "comment_on_first_wait", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { maxBytes: "4096" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.Wait
 */
export const Wait = new Wait$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WaitCondition$Type extends MessageType<WaitCondition> {
    constructor() {
        super("c1.api.policy.v1.WaitCondition", [
            { no: 1, name: "condition", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "4096" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.WaitCondition
 */
export const WaitCondition = new WaitCondition$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WaitDuration$Type extends MessageType<WaitDuration> {
    constructor() {
        super("c1.api.policy.v1.WaitDuration", [
            { no: 1, name: "duration", kind: "message", T: () => Duration, options: { "validate.rules": { duration: { required: true, lt: { seconds: "2592000" } } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.WaitDuration
 */
export const WaitDuration = new WaitDuration$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WaitUntilTime$Type extends MessageType<WaitUntilTime> {
    constructor() {
        super("c1.api.policy.v1.WaitUntilTime", [
            { no: 1, name: "hours", kind: "scalar", T: 13 /*ScalarType.UINT32*/, options: { "validate.rules": { uint32: { lte: 23, gte: 0 } } } },
            { no: 2, name: "minutes", kind: "scalar", T: 13 /*ScalarType.UINT32*/, options: { "validate.rules": { uint32: { lte: 59, gte: 0 } } } },
            { no: 3, name: "timezone", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^(?:[A-Za-z][A-Za-z0-9._+-]*(?:/[A-Za-z0-9._+-]+)+|UTC|GMT)$", ignoreEmpty: true } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.WaitUntilTime
 */
export const WaitUntilTime = new WaitUntilTime$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WaitInstance$Type extends MessageType<WaitInstance> {
    constructor() {
        super("c1.api.policy.v1.WaitInstance", [
            { no: 100, name: "condition", kind: "message", oneof: "until", T: () => WaitConditionInstance },
            { no: 104, name: "until_time", kind: "message", oneof: "until", T: () => WaitUntilTimeInstance },
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "state", kind: "enum", T: () => ["c1.api.policy.v1.WaitInstance.WaitInstanceState", WaitInstance_WaitInstanceState, "WAIT_INSTANCE_STATE_"] },
            { no: 3, name: "started_waiting_at", kind: "message", T: () => Timestamp },
            { no: 4, name: "timeout_duration", kind: "message", T: () => Duration },
            { no: 5, name: "timeout", kind: "message", T: () => Timestamp },
            { no: 6, name: "comment_on_timeout", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { maxBytes: "4096" } } } },
            { no: 7, name: "comment_on_first_wait", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { maxBytes: "4096" } } } },
            { no: 101, name: "succeeded", kind: "message", oneof: "outcome", T: () => WaitInstance_ConditionSucceeded },
            { no: 102, name: "timed_out", kind: "message", oneof: "outcome", T: () => WaitInstance_ConditionTimedOut },
            { no: 103, name: "skipped", kind: "message", oneof: "outcome", T: () => SkippedAction }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.WaitInstance
 */
export const WaitInstance = new WaitInstance$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WaitInstance_ConditionSucceeded$Type extends MessageType<WaitInstance_ConditionSucceeded> {
    constructor() {
        super("c1.api.policy.v1.WaitInstance.ConditionSucceeded", [
            { no: 1, name: "succeeded_at", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.WaitInstance.ConditionSucceeded
 */
export const WaitInstance_ConditionSucceeded = new WaitInstance_ConditionSucceeded$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WaitInstance_ConditionTimedOut$Type extends MessageType<WaitInstance_ConditionTimedOut> {
    constructor() {
        super("c1.api.policy.v1.WaitInstance.ConditionTimedOut", [
            { no: 1, name: "timed_out_at", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.WaitInstance.ConditionTimedOut
 */
export const WaitInstance_ConditionTimedOut = new WaitInstance_ConditionTimedOut$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WaitConditionInstance$Type extends MessageType<WaitConditionInstance> {
    constructor() {
        super("c1.api.policy.v1.WaitConditionInstance", [
            { no: 1, name: "condition", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "4096" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.WaitConditionInstance
 */
export const WaitConditionInstance = new WaitConditionInstance$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WaitUntilTimeInstance$Type extends MessageType<WaitUntilTimeInstance> {
    constructor() {
        super("c1.api.policy.v1.WaitUntilTimeInstance", [
            { no: 1, name: "until_time", kind: "message", T: () => Timestamp },
            { no: 2, name: "duration_if_exists", kind: "message", T: () => Duration }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.policy.v1.WaitUntilTimeInstance
 */
export const WaitUntilTimeInstance = new WaitUntilTimeInstance$Type();
